/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDollarSign} from '@fortawesome/pro-duotone-svg-icons';

const GrantsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faDollarSign} {...props} />
);

export default GrantsIcon;
